import { SELECIONAR_EMISSAO_MDFE } from '../../actions/types'

const estadoInicial = {
  id: null,
  serie: '',
  veiculos: [],
  condutores: [],
  cidadeOrigem: {},
  cidadeDestino: {},
  percursosMdfeDto: [],
  ctesVinculados: []
}

export default function reducerEmissaoMdfeSelecionada(state = estadoInicial, action = null) {
  switch (action.type) {
    case SELECIONAR_EMISSAO_MDFE: {
      if (action.payload == null) {
        return estadoInicial;
      }
      return action.payload;
    }
    default: {
      return state
    }
  }
}
